// some sort of hook to drop template part imports from cli
// Template Part JS Imports
import { acfNavEvents } from "../../template-parts/patterns/acf-main-menu/orion/js/acf-menu-events.js";
import { searchEvents } from "../../template-parts/patterns/search/orion/js/search-events.js";
import { shoppingCartEvents } from "../../template-parts/patterns/shopping-cart/orion/js/shopping-cart-events.js";
import { cartCountEvents } from "../../template-parts/patterns/shopping-cart/orion/js/cart-count-events.js";
import { addToCartEvents } from "../../template-parts/elements/woo-add-to-cart/js/add-to-cart-events.js";
import { formOverlayEvents } from "../../template-parts/patterns/form-overlay/orion/js/form-overlay-events.js";
// import { navEvents } from "../../template-parts/patterns/main-menu/js/menu-events.js";
// import { sidebarEvents } from "../../template-parts/sections/sidebar/ember/js/sidebar-events.js";
import { videoEvents } from "../../template-parts/elements/video/js/video-events.js";
import { sliderEvents } from "../../template-parts/patterns/slider/js/slider-events.js";
import { galleryEvents } from "../../template-parts/patterns/product-gallery/orion/js/gallery-events.js";
import { productSectionGalleryEvents } from "../../template-parts/patterns/product-section-gallery/orion/js/product-section-gallery-events.js";
import { variationEvents } from "../../template-parts/templates/woo-single-product/orion/js/variation-events.js";
import { wcpaPriceEvents } from "../../template-parts/templates/woo-single-product/orion/js/wcpa-price-events.js";
import { chatLauncherEvents } from "../../template-parts/patterns/chat-launcher/orion/js/chat-launcher-events.js";
import { cookieConsentEvents } from "../../template-parts/patterns/cookie-consent/orion/js/cookie-consent-events.js";
import { tabsEvents } from "../../template-parts/sections/woo-tabs/orion/js/tabs-events.js";
import { slideToggleEvents } from "../../template-parts/patterns/list-toggle/orion/js/slide-toggle-events.js";
import { counterEvents } from "../../template-parts/patterns/counter/orion/js/counter-events.js";
import { luigiAnalyticsEvents } from "./luigi-analytics.js";
import { luigiClientRecommendationEvents } from "../../template-parts/sections/luigi-box-suggested-products-client/orion/js/index.js";
import { ga4ServerEvents } from "./ga4-server-events.js";
import { abandonedCartCheckoutEvents } from "./abandoned-cart-checkout.js";
// import { initStickyHeader } from "../../template-parts/sections/header/ember/js/header-events.js";
//import { initAnimations } from "../../template-parts/elements/animations/animations.js";
import { sidebarFilterEvents } from "../../template-parts/sections/woo-sidebar/orion/js/sidebar-filter-events.js";
// import { overlayEvents } from "../../template-parts/templates/testimonials/ember/overlay/js/overlay-events.js";

document.addEventListener("DOMContentLoaded", () => {
	// some sort of hook to drop template part imports from cli
	// Template Part JS Imports
	shoppingCartEvents();
	searchEvents();
	addToCartEvents();
	cartCountEvents();
	formOverlayEvents();
	sidebarFilterEvents();
	acfNavEvents();
	// initStickyHeader();
	// navEvents();
	sliderEvents();
	galleryEvents();
	productSectionGalleryEvents();
	counterEvents();
	cookieConsentEvents();
	luigiAnalyticsEvents();
	luigiClientRecommendationEvents();
	ga4ServerEvents();
	abandonedCartCheckoutEvents();
	variationEvents();
	wcpaPriceEvents();
	chatLauncherEvents();
	tabsEvents();
	// sidebarEvents();
	// //const videos = document.querySelectorAll("div:not([data-acf-template]) > .flux-video");
	const videos = document.querySelectorAll(".flux-video");
	videoEvents(videos);
	slideToggleEvents();
	// overlayEvents();
	//initAnimations({ reverse: true });
});
